<template>
  <article class="articles-wrapper">
    <div class="container">
      <div class="text-wrapper">
        <p class="text0">Articles (연구발표)</p>
      </div>
      <ul>
        <li>
          <div>
            <p>
              김영식, 강승혜, 노상충, '주재원의 글로벌역량과 이문화적응의 관계:
              커리어비전의 조절된 조절-매개효과를 중심으로'
            </p>
            <p
              @click="
                openPage(
                  'https://kr.object.ncloudstorage.com/newglobal/introduce/sub/articles/%EA%B9%80%EC%98%81%EC%8B%9D%2C%20%EA%B0%95%EC%8A%B9%ED%98%9C%2C%20%EB%85%B8%EC%83%81%EC%B6%A9%2C%20%27%EC%A3%BC%EC%9E%AC%EC%9B%90%EC%9D%98%20%EA%B8%80%EB%A1%9C%EB%B2%8C%EC%97%AD%EB%9F%89%EA%B3%BC%20%EC%9D%B4%EB%AC%B8%ED%99%94%EC%A0%81%EC%9D%91%EC%9D%98%20%EA%B4%80%EA%B3%84%3A%20%EC%BB%A4%EB%A6%AC%EC%96%B4%EB%B9%84%EC%A0%84%EC%9D%98%20%EC%A1%B0%EC%A0%88%EB%90%9C%20%EC%A1%B0%EC%A0%88-%EB%A7%A4%EA%B0%9C%ED%9A%A8%EA%B3%BC%EB%A5%BC%20%EC%A4%91%EC%8B%AC%EC%9C%BC%EB%A1%9C%27.pdf'
                )
              "
            >
              원문보기
            </p>
          </div>
          <p>
            한국심리학회지: 산업 및 조직 Korean Journal of Industrial and
            Organizational Psychology 2021. Vol. 34, No. 4, 773-804
          </p>
        </li>
        <li>
          <div>
            <p>노상충, '교육에 들어온 뇌과학, 뇌를 이해하면 교육이 달라진다'</p>
            <p
              @click="
                openPage(
                  'https://kr.object.ncloudstorage.com/newglobal/introduce/sub/articles/%EB%85%B8%EC%83%81%EC%B6%A9%2C%20%27%EA%B5%90%EC%9C%A1%EC%97%90%20%EB%93%A4%EC%96%B4%EC%98%A8%20%EB%87%8C%EA%B3%BC%ED%95%99%2C%20%EB%87%8C%EB%A5%BC%20%EC%9D%B4%ED%95%B4%ED%95%98%EB%A9%B4%20%EA%B5%90%EC%9C%A1%EC%9D%B4%20%EB%8B%AC%EB%9D%BC%EC%A7%84%EB%8B%A4%27.pdf'
                )
              "
            >
              원문보기
            </p>
          </div>
          <p>The-K Magazine, 한국교직원공제회, 2021.11</p>
        </li>
        <li>
          <div>
            <p>김보균, 하이브리드 워크시대, HRD의 역할</p>
            <p
              @click="
                openPage(
                  'https://kr.object.ncloudstorage.com/newglobal/introduce/sub/articles/%EA%B9%80%EB%B3%B4%EA%B7%A0%2C%20%27%ED%95%98%EC%9D%B4%EB%B8%8C%EB%A6%AC%EB%93%9C%20%EC%9B%8C%ED%81%AC%EC%8B%9C%EB%8C%80%2C%20HRD%EC%9D%98%20%EC%97%AD%ED%95%A0%27.pdf'
                )
              "
            >
              원문보기
            </p>
          </div>
          <p>월간 HR insight, 2021.09</p>
        </li>
        <li>
          <div>
            <p>노상충, '리스킬링으로 디지털 변혁을 이루는 방법'</p>
            <p
              @click="
                openPage(
                  'https://kr.object.ncloudstorage.com/newglobal/introduce/sub/articles/%EB%85%B8%EC%83%81%EC%B6%A9%2C%20%27%EB%A6%AC%EC%8A%A4%ED%82%AC%EB%A7%81%EC%9C%BC%EB%A1%9C%20%EB%94%94%EC%A7%80%ED%84%B8%20%EB%B3%80%ED%98%81%EC%9D%84%20%EC%9D%B4%EB%A3%A8%EB%8A%94%20%EB%B0%A9%EB%B2%95%27.pdf'
                )
              "
            >
              원문보기
            </p>
          </div>
          <p>월간 HR insight, 2020.10</p>
        </li>
      </ul>
    </div>
  </article>
</template>
<script>
export default {
  methods: {
    openPage(path) {
      window.open(path, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.articles-wrapper {
  background-color: #f7f7f7;
  padding: 40px 0;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .text-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-bottom: 24px;

    @media screen and (min-width: 1350px) {
      flex-direction: row;
      justify-content: center;
      margin-bottom: 40px;
    }

    .text0 {
      font-size: 33px;
      font-weight: 700;
      text-align: center;

      @media screen and (min-width: 1350px) {
        font-size: 50px;
      }
    }
  }

  ul {
    li {
      &:not(:last-child) {
        margin-bottom: 20px;
      }

      > div {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 5px;

        p {
          &:nth-of-type(1) {
            font-size: 17px;
          }

          &:nth-of-type(2) {
            font-size: 13px;
            color: #de6361;
            cursor: pointer;
          }
        }
      }

      > p {
        font-size: 13px;
        color: #989898;
      }
    }
  }
}
</style>
